import { render, staticRenderFns } from "./pfamilytime.vue?vue&type=template&id=2178d40b&scoped=true&"
import script from "./pfamilytime.vue?vue&type=script&lang=js&"
export * from "./pfamilytime.vue?vue&type=script&lang=js&"
import style0 from "./pfamilytime.vue?vue&type=style&index=0&id=2178d40b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2178d40b",
  null
  
)

export default component.exports